export default __webpack_public_path__ + "static/media/Soulbearer.e41b7c59.jpg";